import { makeStyles } from '@material-ui/core';

type StylesProps = {
  selected: boolean;
};

const MENU_TEXT = '#EAF0F8';
const MENU_TEXT_ACTIVE = '#FFFFFF';
const MENU_ACCENT = '#6DD3B2';
const MENU_ACTIVE = 'rgba(36, 182, 141, 0.22)';
const MENU_HOVER = 'rgba(255, 255, 255, 0.1)';

const useStyles = makeStyles(theme => ({
  button: {
    width: `calc(100% - ${theme.spacing(2)}px)`,
    padding: theme.spacing(1, 2),
    marginBottom: '-8px',
    // @ts-ignore
    color: ({ selected }: StylesProps) => (selected ? MENU_TEXT_ACTIVE : MENU_TEXT),
    backgroundColor: ({ selected }: StylesProps) => (selected ? MENU_ACTIVE : 'transparent'),
    borderRadius: theme.shape.borderRadius,
    '&.MuiButton-root': {
      marginLeft: theme.spacing(1),
      padding: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: MENU_HOVER,
        color: MENU_ACCENT,
        '&.MuiButton-root': {
          padding: theme.spacing(1),
        },
      },
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
    },
    '&.Mui-focusVisible, &:focus-visible': {
      outline: `3px solid ${theme.palette.grey[300]}`,
      outlineOffset: 2,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: MENU_HOVER,
    },
  },
  iconButton: {
    '&.Mui-focusVisible, &:focus-visible': {
      outline: `3px solid ${theme.palette.grey[300]}`,
      outlineOffset: 2,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: MENU_HOVER,
    },
  },
  buttonContent: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    gridGap: theme.spacing(2),
    textTransform: 'none',
    textAlign: 'left',
  },
  dashboardText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
    },
  },
  lockIcon: {
    background: '#0C1727',
    borderRadius: '100%',
    padding: '.5rem',
    height: '2.5rem',
    width: '2.5rem',
    // @ts-ignore
    color: MENU_TEXT,
  },
}));

export default useStyles;
